<script setup lang="ts">
import { polishPlural } from '~~/app/composables/useProductPlural'
import { useQuoteListStore } from '~~/stores/quoteListStore'

/**
 * Licznik Listy Zapytania w nagłówku — odpowiednik ikony koszyka w sklepie,
 * który sprzedaje.
 *
 * Liczba jest w <ClientOnly>, bo lista żyje w localStorage: serwer nie ma jak
 * jej poznać i wyrenderowałby zero, a klient zaraz po hydracji pokazałby inną
 * wartość. Bez tego Vue zgłasza niezgodność hydracji na KAŻDEJ podstronie.
 */
const quoteList = useQuoteListStore()

onMounted(() => quoteList.hydrate())

// Etykieta dla czytnika ekranu: „1 pozycja", „3 pozycje", „5 pozycji" — stałe
// „pozycji" dawało „Lista zapytania: 1 pozycji".
const ariaLabel = computed(() => {
  const count = quoteList.count

  return `Lista zapytania: ${count} ${polishPlural(count, { one: 'pozycja', few: 'pozycje', many: 'pozycji' })}`
})
</script>

<template>
  <NuxtLink
    to="/lista-zapytania"
    class="quote-counter"
    :aria-label="ariaLabel"
  >
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      aria-hidden="true"
    >
      <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
      <rect x="9" y="3" width="6" height="4" rx="1" />
      <path d="M9 12h6M9 16h4" />
    </svg>

    <ClientOnly>
      <span
        v-if="quoteList.count > 0"
        class="quote-counter__badge"
      >{{ quoteList.count }}</span>
    </ClientOnly>
  </NuxtLink>
</template>

<style scoped>
.quote-counter {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: inherit;
}

.quote-counter__badge {
  position: absolute;
  top: -6px;
  right: -8px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 9px;
  background: var(--color-accent, #151515);
  color: var(--color-accent-contrast, #fff);
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}
</style>
